import { useEffect, useState } from 'react';
import { Api } from '../../services/api';
import { CanhotosComponent } from './CanhotosComponent';
import { PerfilComponent } from '../TokenCanvas/PerfilComponent';
import { AtribuirToken } from './AtribuirToken';
import { InfoComponent } from './InfoComponent';

// eslint-disable-next-line
export const CargaCanvas = ({ id }) => {
  const [carga, setCarga] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [optionActive, setOptionActive] = useState({
    canhotos: '',
    token: 'active',
    info: '',
  });

  const handleOption = (option) => {
    const result = {
      canhotos: '',
      token: '',
      info: '',
      [option]: 'active',
    };
    setOptionActive(result);
  };

  const findCarga = async () => {
    const resp = await Api.get(`/carga/${id}`);

    console.log(resp.data);

    setCarga(resp.data);
  };

  const defineToken = (idToken) => {
    setCarga({
      ...carga,
      idToken,
    });
  };

  useEffect(() => {
    findCarga();
  }, []);

  return (
    <>
      {!carga ? (
        <h2>Aguarde um momento...</h2>
      ) : (
        <div>
          <ul className="nav nav-tabs mb-3">
            {optionActive && (
              <>
                <li className="nav-item">
                  <a
                    className={`nav-link ${optionActive.canhotos}`}
                    aria-current="page"
                    onClick={() => handleOption('canhotos')}
                  >
                    Canhotos
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link ${optionActive.token}`}
                    aria-current="page"
                    onClick={() => handleOption('token')}
                  >
                    Token
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link ${optionActive.info}`}
                    aria-current="page"
                    onClick={() => handleOption('info')}
                  >
                    Info
                  </a>
                </li>
              </>
            )}
          </ul>
          {optionActive.canhotos == 'active' && <CanhotosComponent idCarga={id} />}
          {optionActive.token == 'active' &&
            (carga.idToken ? (
              <>
                <PerfilComponent id={carga.idToken} op={{ isCargaView: true, carga: carga.id }} />
              </>
            ) : (
              <AtribuirToken idCarga={id} updateCarga={defineToken} />
            ))}
          {optionActive.info == 'active' && <InfoComponent idCarga={id} />}
          {/* {optionActive.chat == 'active' && <ChatComponent />} */}
        </div>
      )}
    </>
  );
};
